import { InjectionToken } from '@angular/core';

import { ICurrentOrganizationUserDetailsTabPlugin } from '../interfaces';

export const CURRENT_ORGANIZATION_USER_DETAILS_TAB_PLUGIN = new InjectionToken<
  ICurrentOrganizationUserDetailsTabPlugin[]
>('CurrentOrganizationUserDetailsTabPlugin');
